import Vue from 'vue'

export var globalConf = new Vue({
    data: {
        //hostlink: process.env.VUE_APP_API_BASE_URL,
        //hostlink: 'http://localhost:3000/',
        //hostlink: 'http://demo.benchmarkpro.it/api/',
        hostlink: 'https://api.installfit.com/',
        gmaps: 'AIzaSyAXNtsKR3l4qB9TLV09jzwCd9vSppuR1lY',
        valid_type_addr: [
            "street_address",
            "premise",
            "point_of_interest",
            "establishment",
            "hospital",
            "subpremise"
        ]
    }
})